import Link from "next/link";


/**
 * The centered card chrome the auth screens share — the wordmark header, the
 * flat canvas, and the narrow column the `AuthCard` sits in.
 *
 * This markup used to live in `(auth)/layout.tsx`, which forced *every* screen
 * in the group into a `max-w-sm` column. `/signup` needs to break out of that
 * (its redesign candidates are full-bleed, like `/admin/login`), and a layout
 * can't read `searchParams` to opt one route out — so the chrome moved down into
 * a component each page composes, and the layout became a pass-through. Every
 * screen that wants the old look wraps itself in this and renders identically.
 *
 * `isolate` on <main> scopes any negative z-index child so it paints above
 * the muted background tint but still behind the opaque card.
 */
export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-background">
      <header className="container flex h-14 items-center">
        <Link href="/" className="flex items-center gap-2 font-semibold">
          <span className="grid size-7 place-items-center rounded-md bg-primary text-sm text-primary-foreground">
            X
          </span>
          <span className="tracking-tight">Xgodo</span>
        </Link>
      </header>
      <main
        id="main-content"
        className="relative isolate flex flex-1 items-center justify-center overflow-hidden px-4 py-10"
      >
        <div className="w-full max-w-sm">{children}</div>
      </main>
    </div>
  );
}
